import { Box, Link, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { ArrowRightAlt } from '@material-ui/icons';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { constants } from 'helpers/constants';
import React from 'react';
import { CHECKOUT_ELEMENTS_URL } from 'settings';

import styles from './styles';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
  classes?: any;
}

const CheckoutLink = ({ currentProduct, currentUserId, physicalProductPending, classes }: IProps) => {
  const productId = currentProduct.hash ?? currentProduct.id;
  const isAffiliated = currentProduct.producer_id !== currentUserId;
  const urlCustomizeCheckout = `${constants.links.CustomizeCheckout}?productId=${currentProduct.id}`;
  const urlCheckout = `${CHECKOUT_ELEMENTS_URL}/${productId}${isAffiliated ? `?a=${currentUserId}` : ''}`;

  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));

  if (physicalProductPending) {
    return null;
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Typography className={classes.title}>Novo Checkout Sun</Typography>
        <Box className={classes.newsContainer}>
          <Typography className={classes.newsPill}>Novidade!</Typography>
        </Box>
      </Box>

      <Box className={classes.inputContainer}>
        <Box className={classes.inputCopyContainer}>
          <CustomCopyToClipboard fullWidth disableUnderline text={currentProduct ? urlCheckout : ''} />
        </Box>

        {!isMobile && (
          <Link href={urlCustomizeCheckout} className={classes.customizeLink} target='_blank'>
            Personalizar Checkout <ArrowRightAlt fontSize='small' style={{ marginLeft: '0.625rem' }} />
          </Link>
        )}
      </Box>
      <Typography className={classes.informative} component='p'>
        O novo Checkout Sun é mais rápido e seguro e tem uma taxa de conversão até 10% superior
      </Typography>
    </Box>
  );
};

export default styles(CheckoutLink) as any;
